var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "OutBoundHistoryTable" },
    [
      _c("PaginationController", {
        ref: "pagination",
        attrs: {
          getDataActionName: "getArchivedShipments",
          historyLimit: 25,
          searchBoxLabel: _vm.$t("searchByUPC/ASIN/OrderId/Tracking"),
          searchBoxHint: _vm.$t("outBoundHistorySearchBoxHint"),
          select: _vm.isOrganization ? _vm.warehouseSelected : _vm.selectedOrg,
          actionPredicates: _vm.actionPredicates,
          isUsingModelInAction: "",
          haveSearchBox: "",
          haveStartDate: "",
          showSearchBoxLabel: !Boolean(_vm.upc),
          initSearchValue: _vm.upc,
          startDate: _vm.preDate
        },
        scopedSlots: _vm._u([
          {
            key: "dataTable",
            fn: function() {
              return [
                _c("v-data-table", {
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.archivedShipments,
                    expand: _vm.expand,
                    "item-key": "_key",
                    "hide-actions": "",
                    "select-all": _vm.isWarehouse,
                    search: _vm.filterText
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(props) {
                        return [
                          _c("OutboundShipmentRow", {
                            attrs: {
                              type: "history",
                              isHideStar: "",
                              props: props,
                              item: props.item,
                              index: props.index,
                              expanded: props.expanded,
                              siteName: _vm.getSiteName(
                                props.item.products[0] &&
                                  props.item.products[0].warehouseSite
                              )
                            },
                            on: {
                              "update:expanded": function($event) {
                                return _vm.$set(props, "expanded", $event)
                              },
                              "show-details": function(item) {
                                return _vm.showDetails(item)
                              },
                              "show-comments-history": function(item) {
                                return _vm.showDraftComments(item, "history")
                              }
                            }
                          })
                        ]
                      }
                    },
                    {
                      key: "expand",
                      fn: function(props) {
                        return [
                          _c(
                            "v-card",
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { "justify-space-around": "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { sm8: "" } },
                                        [
                                          _c(
                                            "v-layout",
                                            [
                                              _c(
                                                "v-flex",
                                                { attrs: { sm5: "" } },
                                                [
                                                  _vm.isOrganization
                                                    ? _c(
                                                        "v-layout",
                                                        {
                                                          attrs: { column: "" }
                                                        },
                                                        [
                                                          _c("div", [
                                                            _c("b", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "notes"
                                                                  )
                                                                ) + ":"
                                                              )
                                                            ])
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                whiteSpace:
                                                                  "pre-wrap",
                                                                "overflow-wrap":
                                                                  "break-word",
                                                                "max-width":
                                                                  "30vw"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  props.item
                                                                    .note
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("v-spacer"),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                { attrs: { sm5: "" } },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    { attrs: { column: "" } },
                                                    [
                                                      _c("div", [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "instructions"
                                                              )
                                                            ) + ":"
                                                          )
                                                        ])
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            whiteSpace:
                                                              "pre-wrap",
                                                            "overflow-wrap":
                                                              "break-word",
                                                            "max-width": "30vw"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.item
                                                                .instruction
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      !props.item.isMPS
                                                        ? _c(
                                                            "div",
                                                            _vm._l(
                                                              props.item.labels,
                                                              function(item) {
                                                                return _c(
                                                                  "p",
                                                                  {
                                                                    key:
                                                                      item.orderId,
                                                                    staticStyle: {
                                                                      margin:
                                                                        "0"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.trackingNum
                                                                      ) +
                                                                        " ->" +
                                                                        _vm._s(
                                                                          _vm.displayPackaging(
                                                                            item.packaging
                                                                          )
                                                                        )
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        : _c(
                                                            "div",
                                                            [
                                                              _vm._l(
                                                                props.item.labels.reduce(
                                                                  function(
                                                                    merge,
                                                                    label,
                                                                    index
                                                                  ) {
                                                                    var ref =
                                                                      label.packaging
                                                                    var length =
                                                                      ref.length
                                                                    var width =
                                                                      ref.width
                                                                    var height =
                                                                      ref.height
                                                                    var labelPkg =
                                                                      length +
                                                                      "-" +
                                                                      width +
                                                                      "-" +
                                                                      height
                                                                    if (
                                                                      index ===
                                                                      0
                                                                    ) {
                                                                      props.item.pkgMerge = {}
                                                                    }
                                                                    if (
                                                                      !props
                                                                        .item
                                                                        .pkgMerge[
                                                                        labelPkg
                                                                      ]
                                                                    ) {
                                                                      props.item.pkgMerge[
                                                                        labelPkg
                                                                      ] = true
                                                                      label.pkgQty = 1
                                                                      merge.push(
                                                                        label
                                                                      )
                                                                    } else {
                                                                      var targetIndex = merge.findIndex(
                                                                        function(
                                                                          ref
                                                                        ) {
                                                                          var packaging =
                                                                            ref.packaging

                                                                          return (
                                                                            packaging.length ===
                                                                              length &&
                                                                            packaging.width ===
                                                                              width &&
                                                                            packaging.height ===
                                                                              height
                                                                          )
                                                                        }
                                                                      )
                                                                      targetIndex !==
                                                                        -1 &&
                                                                        (merge[
                                                                          targetIndex
                                                                        ].pkgQty += 1)
                                                                    }
                                                                    return merge
                                                                  },
                                                                  []
                                                                ),
                                                                function(item) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key:
                                                                        item.orderId
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.displayPackaging(
                                                                            item.packaging
                                                                          )
                                                                        ) +
                                                                          _vm._s(
                                                                            item.pkgQty ===
                                                                              1
                                                                              ? item.carrier.includes(
                                                                                  "CWT"
                                                                                )
                                                                                ? "   *    " +
                                                                                  ((props
                                                                                    .item
                                                                                    .trackingNumbers &&
                                                                                    props
                                                                                      .item
                                                                                      .trackingNumbers
                                                                                      .length) ||
                                                                                    1)
                                                                                : ""
                                                                              : "   *   " +
                                                                                  item.pkgQty
                                                                          ) +
                                                                          "\n                            "
                                                                      )
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              _vm._v(" "),
                                                              _c("div", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    props.item
                                                                      .trackingNumbers &&
                                                                      props.item.trackingNumbers.join(
                                                                        " "
                                                                      )
                                                                  )
                                                                )
                                                              ])
                                                            ],
                                                            2
                                                          )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.selectedRows,
                    callback: function($$v) {
                      _vm.selectedRows = $$v
                    },
                    expression: "selectedRows"
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "beforeSearchBox",
            fn: function() {
              return [
                _vm.isWarehouse && !_vm.hideSelectedSites
                  ? _c(
                      "v-flex",
                      { attrs: { xs3: "", "mr-5": "" } },
                      [
                        _c("v-autocomplete", {
                          attrs: {
                            items: _vm.warehousesSitesOptions,
                            "item-text": "siteName",
                            "item-value": "key",
                            label: _vm.$t("warehouseSite")
                          },
                          model: {
                            value: _vm.siteKey,
                            callback: function($$v) {
                              _vm.siteKey = $$v
                            },
                            expression: "siteKey"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isOrganization
                  ? [
                      _c(
                        "v-flex",
                        { attrs: { xs3: "", "mr-2": "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              items: _vm.searchModeOptions,
                              "item-text": "modeName",
                              "item-value": "modeKey",
                              label: _vm.$t("searchMode")
                            },
                            model: {
                              value: _vm.searchMode,
                              callback: function($$v) {
                                _vm.searchMode = $$v
                              },
                              expression: "searchMode"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.searchMode === "site"
                        ? _c(
                            "v-flex",
                            { attrs: { md4: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.warehousesSitesOptions,
                                  "item-text": "siteName",
                                  "item-value": "key",
                                  label: _vm.$t("warehouseSite")
                                },
                                model: {
                                  value: _vm.siteKey,
                                  callback: function($$v) {
                                    _vm.siteKey = $$v
                                  },
                                  expression: "siteKey"
                                }
                              })
                            ],
                            1
                          )
                        : _c(
                            "v-flex",
                            { attrs: { md4: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.usersOptions,
                                  "item-text": "name",
                                  "item-value": "uid",
                                  label: _vm.$t("user")
                                },
                                model: {
                                  value: _vm.warehouseSelected,
                                  callback: function($$v) {
                                    _vm.warehouseSelected = $$v
                                  },
                                  expression: "warehouseSelected"
                                }
                              })
                            ],
                            1
                          )
                    ]
                  : _c(
                      "v-flex",
                      { attrs: { md4: "" } },
                      [
                        _c("v-autocomplete", {
                          attrs: {
                            items: _vm.organizationSelect,
                            label: _vm.$t("organization"),
                            "item-text": "displayName",
                            "item-value": "key"
                          },
                          model: {
                            value: _vm.selectedOrg,
                            callback: function($$v) {
                              _vm.selectedOrg = $$v
                            },
                            expression: "selectedOrg"
                          }
                        })
                      ],
                      1
                    )
              ]
            },
            proxy: true
          },
          {
            key: "afterDate",
            fn: function() {
              return [
                _c(
                  "v-flex",
                  { attrs: { md4: "" } },
                  [
                    _vm.isWarehouse
                      ? _c(
                          "v-btn",
                          {
                            attrs: {
                              small: "",
                              color: "primary",
                              loading: _vm.exportLoading
                            },
                            on: { click: _vm.exportExcel }
                          },
                          [_vm._v(_vm._s(_vm.$t("export")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isOrganization
                      ? _c(
                          "v-btn",
                          {
                            staticClass: "ml-2",
                            attrs: { small: "", color: "primary" },
                            on: {
                              click: function($event) {
                                _vm.showOrgExportDialog = true
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("export")))]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { xs4: "" } },
                  [
                    _c("v-text-field", {
                      attrs: { label: _vm.$t("filter"), clearable: "" },
                      model: {
                        value: _vm.filterText,
                        callback: function($$v) {
                          _vm.filterText = $$v
                        },
                        expression: "filterText"
                      }
                    })
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.archivedShipments,
          callback: function($$v) {
            _vm.archivedShipments = $$v
          },
          expression: "archivedShipments"
        }
      }),
      _vm._v(" "),
      _vm.photoServiceDialog
        ? _c(
            "ChatRoom",
            _vm._b(
              {
                attrs: {
                  title: _vm.$t("attachmentDetails"),
                  enableFileUpload: "",
                  createConnection: "",
                  noLastRead: ""
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "issue",
                      fn: function() {
                        return [
                          _c(
                            "v-card",
                            { attrs: { hover: "", raised: "" } },
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "text-xs-left",
                                          attrs: { xs5: "", lg3: "" }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "cardTitle" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("shipmentID")) +
                                                  ":"
                                              )
                                            ]
                                          ),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.archivedShipmentInEdit
                                                  .shipmentKey
                                              ) +
                                              "\n            "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.archivedShipmentInEdit.trackingNum
                                        ? _c(
                                            "v-flex",
                                            {
                                              staticClass: "text-xs-left",
                                              attrs: { xs6: "" }
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "cardTitle" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("tracking")) +
                                                      ":"
                                                  )
                                                ]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.archivedShipmentInEdit
                                                      .trackingNum
                                                  ) +
                                                  "\n            "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "cardTitle",
                                      staticStyle: {
                                        "overflow-wrap": "break-word"
                                      }
                                    },
                                    [
                                      _c("span", { staticClass: "cardTitle" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("shipmentLabel")) + ":"
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "primary", flat: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.getShipmentLabel(
                                                _vm.archivedShipmentInEdit
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("download")))]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.archivedShipmentInEdit.snRecords.length
                                    ? _c("div", { staticClass: "cardtext" }, [
                                        _c(
                                          "span",
                                          { staticClass: "cardTitle" },
                                          [_vm._v(_vm._s(_vm.$t("sn")) + ":")]
                                        ),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.archivedShipmentInEdit.snRecords.join(
                                                ", "
                                              )
                                            )
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.outboundAttachments.length
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "overflow-wrap": "break-word"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "cardTitle" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("photos")) + ":"
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-layout",
                                          { attrs: { row: "", wrap: "" } },
                                          _vm._l(
                                            _vm.outboundAttachments,
                                            function(file, index) {
                                              return _c("FsFileChip", {
                                                key: "file" + index,
                                                staticClass: "ma-2",
                                                attrs: {
                                                  file: file,
                                                  width: "100%",
                                                  "aspect-ratio": "1.7"
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        )
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isWarehouse &&
                                  _vm.archivedShipmentInEdit.workerName
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "overflow-wrap": "break-word"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-layout",
                                            [
                                              _c(
                                                "v-flex",
                                                { attrs: { xs5: "", lg3: "" } },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "cardTitle"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("operator")
                                                        ) + ":"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm
                                                          .archivedShipmentInEdit
                                                          .workerName
                                                      ) +
                                                      "\n              "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                { attrs: { xs6: "" } },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "cardTitle"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("confirmType")
                                                        ) + ":"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          _vm
                                                            .archivedShipmentInEdit
                                                            .confirmType
                                                        ) ||
                                                          _vm.$t(
                                                            "standardConfirm"
                                                          )
                                                      ) +
                                                      "\n              "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isOrganization &&
                                  _vm.archivedShipmentInEdit.creator
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "overflow-wrap": "break-word"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "cardTitle" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("creator")) + ":"
                                              )
                                            ]
                                          ),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.archivedShipmentInEdit
                                                  .creator
                                              ) +
                                              "\n          "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isOrganization &&
                                  _vm.archivedShipmentInEdit.cancelerName
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "overflow-wrap": "break-word"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "cardTitle" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("canceler")) + ":"
                                              )
                                            ]
                                          ),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.archivedShipmentInEdit
                                                  .cancelerName
                                              ) +
                                              "\n          "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isWarehouse &&
                                  _vm.archivedShipmentInEdit.pickupId
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "overflow-wrap": "break-word"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "cardTitle" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("pickupId")) +
                                                  ": "
                                              )
                                            ]
                                          ),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.archivedShipmentInEdit
                                                  .pickupId
                                              ) +
                                              "\n          "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isWarehouse &&
                                  _vm.archivedShipmentInEdit.scannedItems &&
                                  _vm.archivedShipmentInEdit.scannedItems.length
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "overflow-wrap": "break-word"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "cardTitle" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("shipmentFulfillment")
                                                ) + ": "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isWarehouse &&
                                  _vm.archivedShipmentInEdit.scannedItems &&
                                  _vm.archivedShipmentInEdit.scannedItems.length
                                    ? _c("v-data-table", {
                                        attrs: {
                                          headers: [
                                            {
                                              text: "Upc",
                                              value: "upc",
                                              align: "left",
                                              sortable: false
                                            },
                                            {
                                              text: _vm.$t("requiredQuantity"),
                                              value: "requiredQuantity",
                                              align: "left",
                                              sortable: false
                                            },
                                            {
                                              text: _vm.$t("quantity"),
                                              value: "quantity",
                                              align: "left",
                                              sortable: false
                                            }
                                          ],
                                          items:
                                            _vm.archivedShipmentInEdit
                                              .scannedItems || [],
                                          "item-key": "upc",
                                          "hide-actions": ""
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "items",
                                              fn: function(ref) {
                                                var item = ref.item
                                                return [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-xs-left"
                                                    },
                                                    [_vm._v(_vm._s(item.upc))]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-xs-left"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.requiredQuantity
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-xs-left"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.quantity)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          2825447953
                                        )
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isWarehouse &&
                                  _vm.archivedShipmentInEdit
                                    .uploadedTrackings &&
                                  _vm.archivedShipmentInEdit.uploadedTrackings
                                    .length
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "cardTitle",
                                          staticStyle: {
                                            "overflow-wrap": "break-word"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(
                                                _vm.$t("scannedTrackings")
                                              ) +
                                              ":\n          "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isWarehouse &&
                                  _vm.archivedShipmentInEdit.scannedItems &&
                                  _vm.archivedShipmentInEdit.scannedItems.length
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "overflow-wrap": "break-word"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(
                                                _vm.archivedShipmentInEdit
                                                  .uploadedTrackings &&
                                                  _vm.archivedShipmentInEdit.uploadedTrackings.join(
                                                    ", "
                                                  )
                                              ) +
                                              "\n          "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.formattedIMEIRecords.length
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "overflow-wrap": "break-word"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "cardTitle" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("IMEIRecords")
                                                  ) + ": "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("v-data-table", {
                                          attrs: {
                                            headers: [
                                              {
                                                text: _vm.$t("tracking"),
                                                value: "index",
                                                align: "left",
                                                sortable: false,
                                                width: "15%"
                                              },
                                              {
                                                text: _vm.$t("upc"),
                                                value: "upc",
                                                align: "left",
                                                sortable: false,
                                                width: "15%"
                                              },
                                              {
                                                text: _vm.$t("quantity"),
                                                value: "quantity",
                                                align: "left",
                                                sortable: false,
                                                width: "15%"
                                              },
                                              {
                                                text: _vm.$t("IMEI"),
                                                value: "IMEIs",
                                                align: "center",
                                                sortable: false,
                                                width: "60%"
                                              }
                                            ],
                                            items: _vm.formattedIMEIRecords,
                                            "hide-actions": "",
                                            "item-key": "index"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "items",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              props.item
                                                                .tracking
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(props.item.upc)
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.item.IMEIs
                                                              .length
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              props.item.IMEIs.join(
                                                                ","
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            1333495939
                                          )
                                        })
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  2003362724
                ),
                model: {
                  value: _vm.photoServiceDialog,
                  callback: function($$v) {
                    _vm.photoServiceDialog = $$v
                  },
                  expression: "photoServiceDialog"
                }
              },
              "ChatRoom",
              _vm.chatRoomBind,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.draftCommentDialog
        ? _c(
            "ChatRoom",
            _vm._b(
              {
                attrs: {
                  title: _vm.$t("DraftComments"),
                  enableFileUpload: "",
                  createConnection: "",
                  readOnly: !_vm.draftInEdit.isDraft,
                  commentsField: "draftComments"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "issue",
                      fn: function() {
                        return [
                          _c(
                            "v-card",
                            { attrs: { hover: "", raised: "" } },
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "div",
                                    { staticClass: "chatroom-text-block" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("shipmentID")) +
                                            ": " +
                                            _vm._s(
                                              _vm.draftInEdit.requestId ||
                                                _vm.draftInEdit._key
                                            )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("createTime")) +
                                            ": " +
                                            _vm._s(
                                              _vm.toTimestampString(
                                                _vm.draftInEdit.createTime
                                              )
                                            )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "chatroom-text-block" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("tracking")) +
                                            ": " +
                                            _vm._s(_vm.draftInEdit.trackingNum)
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("packageQuantity")) +
                                            ": " +
                                            _vm._s(_vm.draftInEdit.packageQty)
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "chatroom-text-block" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("totalCost")) +
                                            ": $" +
                                            _vm._s(
                                              (
                                                Object.values(
                                                  _vm.draftInEdit.products
                                                ) || []
                                              )
                                                .reduce(function(acc, item) {
                                                  return (
                                                    acc +
                                                    item.toShip *
                                                      (item.unitCost || 0)
                                                  )
                                                }, 0)
                                                .toLocaleString()
                                            )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("totalPrice")) +
                                            ": $" +
                                            _vm._s(
                                              (
                                                Object.values(
                                                  _vm.draftInEdit.products
                                                ) || []
                                              )
                                                .reduce(function(acc, item) {
                                                  return (
                                                    acc +
                                                    item.toShip *
                                                      (item.unitPrice || 0)
                                                  )
                                                }, 0)
                                                .toLocaleString()
                                            )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "chatroom-text-block" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("destination")) +
                                            ": " +
                                            _vm._s(
                                              _vm.draftInEdit.destination &&
                                                (_vm.draftInEdit.destination
                                                  .name === "-- Other --"
                                                  ? _vm.draftInEdit.destination
                                                      .content
                                                  : _vm.draftInEdit.destination
                                                      .name)
                                            )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("products")) +
                                        ":\n          "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        [
                                          JSON.stringify(
                                            _vm.draftInEdit.products
                                          ) !== "{}"
                                            ? _c("v-data-table", {
                                                staticClass: "elevation-1",
                                                attrs: {
                                                  headers: [
                                                    {
                                                      text: "#",
                                                      value: "",
                                                      align: "left",
                                                      sortable: false
                                                    },
                                                    {
                                                      text: _vm.$t(
                                                        "productName"
                                                      ),
                                                      value: "productName",
                                                      align: "left",
                                                      sortable: true
                                                    },
                                                    {
                                                      text: "UPC",
                                                      value: "",
                                                      align: "left",
                                                      sortable: false
                                                    },
                                                    {
                                                      text:
                                                        _vm.$t("quantity") +
                                                        "(" +
                                                        Object.values(
                                                          _vm.draftInEdit
                                                            .products
                                                        ).reduce(function(
                                                          acc,
                                                          item
                                                        ) {
                                                          return (
                                                            acc + item.toShip
                                                          )
                                                        },
                                                        0) +
                                                        ")",
                                                      value: "",
                                                      align: "left",
                                                      sortable: false
                                                    },
                                                    {
                                                      text: _vm.$t("unitCost"),
                                                      value: "",
                                                      align: "left",
                                                      sortable: false
                                                    },
                                                    {
                                                      text: _vm.$t("unitPrice"),
                                                      value: "",
                                                      align: "left",
                                                      sortable: false
                                                    },
                                                    {
                                                      text: _vm.$t("totalCost"),
                                                      value: "",
                                                      align: "left",
                                                      sortable: false
                                                    },
                                                    {
                                                      text: _vm.$t(
                                                        "totalPrice"
                                                      ),
                                                      value: "",
                                                      align: "left",
                                                      sortable: false
                                                    }
                                                  ],
                                                  items: Object.values(
                                                    _vm.draftInEdit.products
                                                  ).map(function(item) {
                                                    return Object.assign(
                                                      {},
                                                      item,
                                                      {
                                                        productName: _vm.getUpcName(
                                                          item
                                                        )
                                                      }
                                                    )
                                                  }),
                                                  "item-key": "fbmKey",
                                                  "hide-actions": ""
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "items",
                                                      fn: function(ref) {
                                                        var item = ref.item
                                                        var index = ref.index
                                                        return [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "text-xs-left"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  index + 1
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "text-xs-left"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.productName
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "text-xs-left"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                      " +
                                                                  _vm._s(
                                                                    item.upc
                                                                  ) +
                                                                  "\n                    "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "text-xs-left"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                      " +
                                                                  _vm._s(
                                                                    item.toShip
                                                                  ) +
                                                                  "\n                    "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "text-xs-left"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                      $" +
                                                                  _vm._s(
                                                                    (
                                                                      item.unitCost ||
                                                                      0
                                                                    ).toLocaleString()
                                                                  ) +
                                                                  "\n                    "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "text-xs-left"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                      $" +
                                                                  _vm._s(
                                                                    (
                                                                      item.unitPrice ||
                                                                      0
                                                                    ).toLocaleString()
                                                                  ) +
                                                                  "\n                    "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "text-xs-left"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                      $" +
                                                                  _vm._s(
                                                                    (
                                                                      item.toShip *
                                                                      (item.unitCost ||
                                                                        0)
                                                                    ).toLocaleString()
                                                                  ) +
                                                                  "\n                    "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "text-xs-left"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                      $" +
                                                                  _vm._s(
                                                                    (
                                                                      item.toShip *
                                                                      (item.unitPrice ||
                                                                        0)
                                                                    ).toLocaleString()
                                                                  ) +
                                                                  "\n                    "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  744225914
                                                )
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "chatroom-text-block",
                                      staticStyle: {
                                        "overflow-wrap": "break-word",
                                        "white-space": "pre-wrap"
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("note")) +
                                            ": " +
                                            _vm._s(_vm.draftInEdit.note)
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  268278502
                ),
                model: {
                  value: _vm.draftCommentDialog,
                  callback: function($$v) {
                    _vm.draftCommentDialog = $$v
                  },
                  expression: "draftCommentDialog"
                }
              },
              "ChatRoom",
              _vm.chatRoomBind,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showOrgExportDialog
        ? _c("FormSubmitPopup", {
            attrs: {
              title: _vm.$t("exportShipmentHistory"),
              rightMethod: _vm.exportOrgData,
              rightButtonLoading: _vm.orgExportLoading
            },
            on: {
              popupClose: function() {
                _vm.showOrgExportDialog = false
                _vm.orgExportSiteKey = ""
                _vm.orgExportLoading = false
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c(
                        "v-layout",
                        { attrs: { column: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", "mb-3": "" } },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("v-select", {
                                    staticStyle: { "min-width": "100px" },
                                    attrs: {
                                      items: _vm.timeZones,
                                      label: _vm.$t("timeZone")
                                    },
                                    model: {
                                      value: _vm.timeZone,
                                      callback: function($$v) {
                                        _vm.timeZone = $$v
                                      },
                                      expression: "timeZone"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("DatePicker", {
                                    attrs: {
                                      isShowIcon: false,
                                      label: "date",
                                      range: "",
                                      mode: "date",
                                      max: _vm.dateMax,
                                      min: _vm.dateMin
                                    },
                                    model: {
                                      value: _vm.dates,
                                      callback: function($$v) {
                                        _vm.dates = $$v
                                      },
                                      expression: "dates"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.warehousesSitesOptions,
                                  "item-text": "siteName",
                                  "item-value": "key",
                                  label: _vm.$t("warehouseSite")
                                },
                                model: {
                                  value: _vm.orgExportSiteKey,
                                  callback: function($$v) {
                                    _vm.orgExportSiteKey = $$v
                                  },
                                  expression: "orgExportSiteKey"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              2505638476
            ),
            model: {
              value: _vm.showOrgExportDialog,
              callback: function($$v) {
                _vm.showOrgExportDialog = $$v
              },
              expression: "showOrgExportDialog"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7fdae1ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fdae1ba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OutBoundHistoryTable.vue
// module id = null
// module chunks = 